import { doodBlockConfig } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const INFORMATIONSCONTAINERBLOCK_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  informationsContainerBlockDescriptor: _generatedInformationsContainerBlockDescriptor,
  informationsContainerBlockBlocDefinition,
  informationsContainerBlockDashboardLayout,
  informationsContainerBlockConfig,
  informationsContainerBlockResolveConfig,
  informationsContainerBlockProperties,
} = doodBlockConfig(
  {
    name: "Informations container",
    componentType: 'InformationsContainerBlockComponent',
    category: 'content',
    description: "Informations container.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {},
    slots: [
      {
        key: 'columns',
        name: 'pages.blocks.informations-container.columns.label',
        accept: 'explicitOnly',
        allowedTypes: ["InformationsTextBlock", "InformationsColumnBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.informations-container.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.informations-container.fieldset.columns.label",
            fields: ["columns"],
          },
        ],
      },
    ],
  })
);

export function informationsContainerBlockDescriptor(): IBlockDescriptor;
export function informationsContainerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function informationsContainerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedInformationsContainerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedInformationsContainerBlockDescriptor, informationsContainerBlockProperties, fieldOrder);
}

export {
  informationsContainerBlockBlocDefinition,
  informationsContainerBlockDashboardLayout,
  informationsContainerBlockProperties,
  informationsContainerBlockConfig,
  informationsContainerBlockResolveConfig,
};

export type InformationsContainerBlockConfig = typeof informationsContainerBlockConfig;
